import type { RawEditorOptions } from 'tinymce';
import {
  collectPluginsForButtons,
  CoreEditorButton,
  CustomEditorButton,
  editorSettingsBase
} from '../editor/EditorHelper';

/**
 * Editor settings used for "Custom Field" instances of the editor.
 *
 */
export function editorSettingsForCustomField(): RawEditorOptions {
  const toolbar = [
    {
      name: 'toolbar.group.text.format',
      items: [CoreEditorButton.FORMAT_SELECT]
    },
    {
      items: [CoreEditorButton.SEPARATOR]
    },
    {
      name: 'toolbar.group.text.styles',
      items: [
        CoreEditorButton.BOLD,
        CoreEditorButton.ITALIC,
        CoreEditorButton.UNDERLINE,
        CoreEditorButton.STRIKETHROUGH,
        CoreEditorButton.FORECOLOR
      ]
    },
    {
      items: [CoreEditorButton.SEPARATOR]
    },
    {
      name: 'toolbar.group.lists',
      items: [CoreEditorButton.BULL_LIST, CoreEditorButton.NUM_LIST]
    },
    {
      items: [CoreEditorButton.SEPARATOR]
    },
    {
      name: 'toolbar.group.alignment',
      items: [CoreEditorButton.ALIGN]
    },
    {
      items: [CoreEditorButton.SEPARATOR]
    },
    {
      name: 'toolbar.group.link.media.emoji',
      items: [CustomEditorButton.LINK]
    },
    {
      items: [CoreEditorButton.SEPARATOR]
    },
    {
      name: 'toolbar.group.insert.blockquote',
      items: [CoreEditorButton.BLOCKQUOTE]
    },
    {
      items: [CoreEditorButton.SEPARATOR]
    },
    {
      name: 'toolbar.group.insert.table',
      items: [CoreEditorButton.TABLE]
    },
    {
      items: [CoreEditorButton.SEPARATOR]
    },
    {
      name: 'toolbar.group.indentation',
      items: [CoreEditorButton.INDENT, CoreEditorButton.OUTDENT]
    },
    {
      items: [CoreEditorButton.SEPARATOR]
    },
    {
      name: 'toolbar.group.toc.formatting.code.help',
      items: [
        CustomEditorButton.TOC,
        CoreEditorButton.REMOVE_FORMAT,
        CustomEditorButton.SOURCE_CODE,
        CustomEditorButton.HELP
      ]
    }
  ];

  const mobileToolbar = [
    {
      name: 'toolbar.group.text.format',
      items: [CoreEditorButton.FORMAT_SELECT]
    },
    {
      items: [CoreEditorButton.SEPARATOR]
    },
    {
      name: 'toolbar.group.text.styles',
      items: [
        CoreEditorButton.BOLD,
        CoreEditorButton.ITALIC,
        CoreEditorButton.UNDERLINE,
        CoreEditorButton.STRIKETHROUGH,
        CoreEditorButton.FORECOLOR
      ]
    },
    {
      items: [CoreEditorButton.SEPARATOR]
    },
    {
      name: 'toolbar.group.lists',
      items: [CoreEditorButton.BULL_LIST, CoreEditorButton.NUM_LIST]
    },
    {
      items: [CoreEditorButton.SEPARATOR]
    },
    {
      name: 'toolbar.group.alignment',
      items: [CoreEditorButton.ALIGN]
    },
    {
      items: [CoreEditorButton.SEPARATOR]
    },
    {
      name: 'toolbar.group.insert.blockquote',
      items: [CoreEditorButton.BLOCKQUOTE]
    },
    {
      items: [CoreEditorButton.SEPARATOR]
    },
    {
      name: 'toolbar.group.code.indentation',
      items: [CustomEditorButton.CODE_SAMPLE, CoreEditorButton.INDENT, CoreEditorButton.OUTDENT]
    },
    {
      items: [CoreEditorButton.SEPARATOR]
    },
    {
      name: 'toolbar.group.toc.formatting',
      items: [CustomEditorButton.TOC, CoreEditorButton.REMOVE_FORMAT]
    }
  ];

  const plugins = collectPluginsForButtons([...toolbar, ...mobileToolbar]);

  return {
    ...editorSettingsBase(),
    plugins,
    toolbar,
    mobile: {
      toolbar: mobileToolbar
    }
  };
}
